__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/4fde279c7d27713165f6fb14fec1130a2478013e/_next/";